var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSiteVisitorsIcon = function SvgSiteVisitorsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#D8D8D8",
    cx: 18,
    cy: 18,
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10a8 8 0 1 1 0 16 8 8 0 0 1 0-16Zm0 1c-1.058 0-2.06.235-2.96.655l.03-.048c-.161.222-.186.594-.091 1.311l.111.787c.147 1.154.063 1.642-.533 2.06-.972.682-1.755.183-2.661-1.055l-.043-.06A6.969 6.969 0 0 0 11 18c0 .638.085 1.256.245 1.844l.066.069c.562.635 1.21.737 1.887.044l.113-.123c1.57-1.804 4.168-.394 3.464 2.282l-.055.189c-.21.668-.265 1.133-.23 1.594l.063.55c.014.14.019.273.014.403a7 7 0 0 0 8.429-6.59c-.44.297-.829.554-1.178.975l-.086.117-.103.157-.254.4-.15.228-.163.233c-.568.78-1.363 1.527-2.28.84-.107-.081-.213-.244-.323-.447l-.17-.331-.178-.362c-.153-.306-.32-.61-.51-.835a7.555 7.555 0 0 0-.797-.806l-.289-.24c-1.202-.983-1.558-1.605-.915-2.634.17-.271.35-.492.658-.794l.257-.244.317-.286.768-.681c.907-.826 1.28-1.346 1.258-1.807l-.027-.15A6.98 6.98 0 0 0 18 11Z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};
export default SvgSiteVisitorsIcon;